export default __webpack_public_path__ + "static/media/icon-check.91b0344e.svg";